import { render, staticRenderFns } from "./InfoModify.vue?vue&type=template&id=4e8b4dd9&"
import script from "./InfoModify.vue?vue&type=script&lang=js&"
export * from "./InfoModify.vue?vue&type=script&lang=js&"
import style0 from "./InfoModify.vue?vue&type=style&index=0&lang=less&"
import style1 from "./InfoModify.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports